import UpshowLogger from '../../Logger';
import { CONTENT_TYPE } from '../../epg/constants/event';

// Boot waits on the live events request, and it has no timeout of its own.
export const LIVE_EVENTS_TIMEOUT_MS = 5000;

function withTimeout (promise, ms) {
  let timer;
  const timeout = new Promise((_, reject) => {
    timer = setTimeout(() => reject(new Error(`timed out after ${ms}ms`)), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}

// A failed live events lookup runs the test.
export async function shouldRunBootTest ({ fetchLiveEvents }) {
  try {
    const liveEvents = await withTimeout(fetchLiveEvents(), LIVE_EVENTS_TIMEOUT_MS);
    const activeContent = liveEvents && liveEvents.activeLiveContent;
    if (activeContent && activeContent.contentType === CONTENT_TYPE.LIVE_EVENT) {
      UpshowLogger.log(['readiness', 'bootGate'], 'live event active — skipping boot test');
      return false;
    }
  } catch (err) {
    UpshowLogger.error(['readiness', 'bootGate'], 'live events fetch failed — running boot test', err);
  }

  return true;
}
